<template>
    <v-speed-dial
        v-model="fab"
        :open-on-hover="false"
        :direction="$vuetify.breakpoint.smAndDown ? 'bottom' : 'left'"
        :transition="
            $vuetify.breakpoint.smAndDown
                ? 'slide-y-transition'
                : 'slide-x-transition'
        "
        absolute
    >
        <template v-slot:activator>
            <v-btn v-model="fab" icon>
                <v-icon large>
                    {{
                        $vuetify.breakpoint.smAndDown
                            ? 'mdi-dots-horizontal'
                            : 'mdi-dots-vertical'
                    }}
                </v-icon>
            </v-btn>
        </template>
        <v-btn large fab color="blue" @click="openModHeadersTableDialog">
            <v-icon color="white" size="35">mdi-pencil</v-icon>
        </v-btn>
        <v-btn large fab color="orange" @click="openFilterDialog">
            <v-icon color="white" size="35">mdi-magnify</v-icon>
        </v-btn>
        <v-btn large color="green" fab @click="openDownload">
            <v-icon color="white" size="35"> mdi-microsoft-excel </v-icon>
        </v-btn>
        <v-btn large color="purple" fab @click="downloadImage">
            <v-icon color="white" size="35"> mdi-camera </v-icon>
        </v-btn>
        <v-btn large color="deep-purple" dark fab @click="openInfo">
            <v-icon size="35">mdi-information-outline</v-icon>
        </v-btn>
    </v-speed-dial>
</template>

<script>
import { mapState } from 'vuex';

export default {
    name: 'Dial',
    data: () => ({
        items: [
            {
                title: 'Clientes',
                icon: 'mdi-account',
                text: 'Número de clientes a los que se ha atendido',
            },
            {
                title: 'Clientes creados',
                icon: 'mdi-account-multiple-plus',
                text: 'Número de clientes creados',
            },
            {
                title: 'Atenciones',
                icon: 'mdi-account-plus',
                text: 'Número de atenciones realizadas',
            },
            {
                title: 'Agendado',
                icon: 'mdi-calendar-cursor',
                text: 'Número de gendaciones realizadas',
            },
            {
                title: 'Gestiones',
                icon: 'mdi-account-cog',
                text: 'Número de gestiones realizadas',
            },
            {
                title: 'No contesta',
                icon: 'mdi-phone-missed',
                text: 'Número de llamadas no contestadas',
            },
            {
                title: 'No interesado',
                icon: 'mdi-phone-cancel',
                text: 'Número de clientes no interesados',
            },
            {
                title: 'Ofertado',
                icon: 'mdi-offer',
                text: 'Número de ofertas realizadas',
            },
            {
                title: 'Rechazado',
                icon: 'mdi-close-circle',
                text: 'Número de ofertas rechazadas',
            },
            {
                title: 'Total de ventas',
                icon: 'mdi-tag',
                text: 'Número de ofertas vendidas',
            },
            {
                title: 'Ventas valor',
                icon: 'mdi-flag',
                text: 'Número total de Fijos y Pospago vendidos',
            },
            {
                title: 'Total de atenciones vendidas',
                icon: 'mdi-flag-triangle',
                text: 'Número de ofrrtas vendidas y gestiones realizadas',
            },
        ],
        fab: false,
        legend: false,
    }),
    computed: {
        selectedComerciales: {
            get() {
                return this.$store.state.gerencia.selectedComerciales;
            },
            set(val) {
                this.$store.commit('gerencia/selectedComerciales', val);
            },
        },
        ...mapState('gerencia', {
            comerciales: (state) => state.comerciales,
            comercialesInfo: (state) => state.comercialesInfo,
        }),
    },
    methods: {
        openInfo() {
            this.$store.commit('util/isOpenLegendDialog', true);
        },
        openFilterDialog() {
            ///////////////PARA COGER LOS ELEMENTOS COMPLETOS/////////////////=
            // this.selectedComerciales = JSON.parse(
            //     JSON.stringify(this.comerciales.map((item) => { return {'id': item.id, 'nombre_completo': item.nombre_completo}  }))
            //     );
            ////////////////////////////////////////////////////////////////
            this.$store.commit('gerencia/isOpenFilterDialog', true);
        },
        openModHeadersTableDialog() {
            this.$store.commit('gerencia/isOpenModHeadersDialog', true);
        },
        openDownload() {
            this.$store.dispatch('gerencia/exportDB');
        },
        downloadImage() {
            let obj = {
                elementId: 'comercialesTable',
                downloadName: 'comercialesTable',
            };

            this.$store.dispatch('util/printThis', obj);
        },
    },
};
</script>
